import { ValidationKey } from '@/constants/validation-key';
import { ValidationReturn } from '@/validators/countryInstanceValidators';

export function emailValidation(value: string): ValidationReturn {
    const pattern = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        'g'
    );
    const isValid = pattern.test(value);
    return !isValid ? ValidationKey.PleaseEnterValidEmail : undefined;
}
